/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import getGlobalClerkIntlContent from 'locale/getGlobalClerkIntlContent';
import App from './App';
import { getClerkLocale, getCustomClerkLocalizations } from './utils/useClerkLocale';

const ClerkAppWrapper = () => {
  const clerkLocale = getClerkLocale('de-CH');
  const globalOverrides = getGlobalClerkIntlContent('de-CH');
  const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

  return (
    <Router>
      <ClerkProvider
        publishableKey={publishableKey}
        afterSignOutUrl="/"
        localization={getCustomClerkLocalizations({ clerkLocale, globalOverrides })}
      >
        <App />
      </ClerkProvider>
    </Router>
  );
};

export default ClerkAppWrapper;
